import React from "react";

const ArrowLeft = ({size=24, className}) => (
	<div className="cursor-pointer m-auto">
		<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`stroke-current ${className}`}
      >
			<path d="M19 12H6M12 5l-7 7 7 7"/>
		</svg>
	</div>
	
)
		
export {ArrowLeft};